import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js';
export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}
 
platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.error(err));



// https://github.com/angular/angular/issues/34970
//export { renderModule, renderModuleFactory } from '@angular/platform-server';
